<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card >
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <transition name="zoom-fade">
                                <div class="p-8" v-if="show">
                                    <div class="vx-card__title mb-8">
                                        <h4 class="mb-4">{{$t('Recover your password')}}</h4>
                                        <p>{{$t('Please enter your email address to receive an email with a verification code.')}}</p>
                                    </div>
                                    <form autocomplete="off" class="mb-base">
                                        <vs-input
                                          v-validate="'required|email|min:3'"
                                          name="email"
                                          icon-no-border
                                          icon="icon icon-user"
                                          icon-pack="feather"
                                          :label-placeholder="$t('Email')"
                                          v-model="email"
                                          :readonly="codeBox"
                                          class="w-full" :class="[errors.first('email') ? 'border-danger' :'']"/>

                                        <div v-if="codeBox" class="mt-base">
                                            <p>
                                              {{$t('An email containing the verification code was sent to you and please enter the code.')}} ({{$t('The email may be in the Spam or Promotions folder.')}})
                                            </p>
                                            <vs-input
                                              v-validate="'required|min:5'"
                                              name="code"
                                              icon-no-border
                                              icon="icon icon-hash"
                                              icon-pack="feather"
                                              :label-placeholder="$t('Verification Code')"
                                              v-model="code"
                                              class="w-full" :class="[errors.first('code') ? 'border-danger' :'']"/>
                                        </div>
                                    </form>
                                    <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">{{$t('Back To Login')}}</vs-button>

                                    <vs-button  @click="submitForm(false)" id="button-send-mail" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">
                                      {{$t('Recover Password')}}
                                    </vs-button>
                                    <vs-button v-if="codeBox" @click="submitForm(true)" :disabled="countdownEmail!=0" color="success"
                                               id="button-resend-mail" class="float-right mr-1 px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">
                                      <feather-icon icon="SendIcon" svgClasses="h-4 w-4" v-if="countdownEmail==0"/>{{countdownEmail!=0? countdownEmail: null}}
                                    </vs-button>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<i18n locale="fa">
{
  "Recover your password":"بازیابی رمز عبور"
  ,"Please enter your email address to receive an email with a verification code.":
  "لطفاً آدرس ایمیل خود را وارد کنید تا ایمیل حاوی کد تایید برای شما ارسال گردد."
  ,"Back To Login":"بازگشت به ورود"
  ,"Recover Password":"بازیابی رمز"

  ,"An email containing the verification code was sent to you and please enter the code.":
  "ایمیلی شامل کد تایید برای شما ارسال گردید و لطفا کد را درج کنید."
  ,"The email may be in the Spam or Promotions folder.":
  "ممکن است ایمیل در پوشه Spam یا Promotions باشد."
  ,"Verification Code": "کد تایید"
}
</i18n>
<script>

  import axios from '../../../http/axios'

  export default {
  data () {
    return {
      show: false,
      codeBox: false,
      email: '',
      code: '',
      sitekey: '6LepZGocAAAAANMarNorlQoVxXJqsYPRwOX21CrM',
      recaptcha: null,
      numberCountDown: 120,
      countdownEmail: null
    }
  },
  methods:{
    submitForm (resend = false) {
      this.$validator.validateAll()
      if ((!this.validateForm && !resend) || !this.checkLogin()) return

      // Loading
      if(!resend)this.$vs.loading({container: '#button-send-mail', scale: 0.65});
      else this.$vs.loading({container: '#button-resend-mail', scale: 0.65});

      const self = this
      grecaptcha.execute(this.sitekey, {action:'validate_captcha'})
        .then(function (token) {
          self.recaptcha = token

          axios.post('forget',{email:self.email,code:self.code,recaptcha:self.recaptcha})
            .then(function (response) {
              if (response.data.status == true) {
                self.$vs.notify({
                  title: self.$t('Success'),
                  text: response.data.msg,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success'
                })
                if(response.data.tokenForget){
                  localStorage.setItem('tokenForget',response.data.tokenForget)
                  localStorage.setItem('emailForget',self.email)
                  self.$router.push('/reset-password').catch(() => {})
                  return false
                }
                self.codeBox = true;
                self.counterDownEmail()
              } else {
                self.$vs.notify({
                  title: self.$t('Error'),
                  text: response.data.msg,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
              }
              if(!resend) self.$vs.loading.close('#button-send-mail > .con-vs-loading');
              else  self.$vs.loading.close('#button-resend-mail > .con-vs-loading');
            })
            .catch(function (error) {
              console.log(error)
              if(!resend) self.$vs.loading.close('#button-send-mail > .con-vs-loading');
              else  self.$vs.loading.close('#button-resend-mail > .con-vs-loading');
            })
      })
    },
    counterDownEmail () {
      if (this.countdownEmail <= 0) this.countdownEmail = this.numberCountDown
      var interval = setInterval(() => {
        this.countdownEmail = this.countdownEmail - 1
        if (this.countdownEmail == 0)  window.clearInterval(interval)
      }, 1000)
    },
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        this.$vs.loading.close()
        this.$vs.notify({
          title: this.$t('Login Attempt'),
          text: this.$t('You are already logged in!'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        this.$router.push('/').catch(() => {})
        return false
      }
      return true
    },
  },
  mounted() {
    this.show = true
    const plugin = document.createElement('script')
    plugin.setAttribute(
      'src',
      `https://www.google.com/recaptcha/api.js?render=${this.sitekey}`
    )
    plugin.setAttribute('id',`grecaptcha-badge`)
    plugin.async = true
    document.head.appendChild(plugin)
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && (this.code !== '' || this.codeBox === false)
    }
  },
  beforeDestroy() {
    document.getElementsByClassName("grecaptcha-badge")[0].remove();
    document.getElementById("grecaptcha-badge").remove();
  },
}
</script>
